import { usePaginatedQuery } from 'react-query';
import { listDrugs } from 'src/services/api/drugs';

function useListDrugs(query) {
  return usePaginatedQuery(['drugs', query], (key, query) => listDrugs(query));
}

export default useListDrugs;
